import { useContext } from "react";
import NodeContext from "../../utils/NodeContext";
import "./Sidebar.component.scss";

export default function SidebarResearcher({ setSelectedNode, isOpen }) {
	const { primaryNode } = useContext(NodeContext);
	return (
		<div className={isOpen ? "block" : "hidden"}>
			{primaryNode.imgsrc ? (
				<img
					className="w-full h-auto"
					src={primaryNode.imgsrc}
					alt={primaryNode.name}
				/>
			) : null}
			<div className="p-6">
				{primaryNode.name ? (
					<h3 className="text-4xl font-light mb-4">{primaryNode.name}</h3>
				) : null}
				<div className="my-4 py-4 space-y-2">
					<span className="text-sm uppercase font-semibold">Location</span>
					<div>{primaryNode.locations}</div>
				</div>
				<div className="my-4 py-4 space-y-2 focus-block">
					<span className="text-sm uppercase font-semibold focus-heading">
						Areas of Focus
					</span>
					<ul
						className="researcher__focus px-0"
						dangerouslySetInnerHTML={{ __html: primaryNode.areas_of_focus }}
					/>
				</div>
				<div className="my-4 py-4 space-y-2">
					<span className="text-sm uppercase font-semibold">
						Similar Researchers
					</span>
					<p>
						{primaryNode.similar.map((similar_node) => {
							return (
								<button
									className="pr-3 text-white"
									onClick={() => setSelectedNode(similar_node)}
								>
									{similar_node.name}
								</button>
							);
						})}
					</p>
				</div>
				{primaryNode.profileURL ? (
					<a
						href={primaryNode.profileURL}
						target="_blank"
						rel="noreferrer"
						className="block py-4 uppercase profile-link"
					>
						View full profile &rarr;
					</a>
				) : null}
				{primaryNode.bio ? (
					<div
						className="space-y-3 text-cut"
						dangerouslySetInnerHTML={{ __html: primaryNode.bio }}
					/>
				) : null}
			</div>
		</div>
	);
}
